import React from "react";

// Matches travel-qr Input exactly: plain <input> with label above, same Tailwind-equivalent styles
export default function TravelInput({
  title,
  placeholder,
  type = "text",
  inputValue,
  onChange,
  name,
  id,
  isValid = true,
  errorText,
  maxLength,
  min,
  max,
  isDisabled = false,
  isReadOnly = false,
  icon,
}) {
  const safeValue = inputValue ?? "";

  const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    padding: "12px 16px",
    fontFamily: "'Gilroy', -apple-system, Roboto, Helvetica, sans-serif",
    fontSize: 14,    /* mobile: text-sm */
    fontWeight: 500, /* font-medium */
    color: "#282828",
    border: isValid ? "1px solid #E0E0E0" : "1px solid #ef4444",
    borderRadius: 8,
    outline: "none",
    transition: "border-color 0.15s",
    backgroundColor: isDisabled || isReadOnly ? "white" : "white",
    appearance: "none",
    WebkitAppearance: "none",
    display: "block",
    paddingRight: icon ? "48px" : "16px",
    /* Prevent Chrome autofill background color */
    WebkitTextFillColor: "#282828",
    transition: "background-color 5000s ease-in-out 0s",
  };

  const labelStyle = {
    display: "block",
    fontFamily: "'Gilroy', -apple-system, Roboto, Helvetica, sans-serif",
    fontSize: 12,    /* mobile: text-xs */
    fontWeight: 400, /* font-normal */
    color: "#737070",
    marginBottom: 4,
  };

  const errorStyle = {
    color: "#991b1b",
    fontFamily: "'Gilroy', -apple-system, Roboto, Helvetica, sans-serif",
    fontWeight: 500,
    fontSize: 12,
    marginTop: 8,
  };

  return (
    <div style={{ width: "100%" }}>
      <div style={{ marginBottom: 4 }}>
        {title && (
          <label htmlFor={id} style={labelStyle}>
            {title}
          </label>
        )}
        <div style={{ position: "relative" }}>
          <input
            id={id}
            name={name}
            type={type}
            readOnly={isReadOnly}
            disabled={isDisabled}
            placeholder={type === "date" ? undefined : placeholder}
            min={min}
            max={max}
            maxLength={maxLength}
            value={safeValue}
            onChange={onChange}
            style={inputStyle}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = "#079f9f";
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = isValid ? "#E0E0E0" : "#ef4444";
            }}
          />
          {icon && (
            <img 
              src={icon} 
              alt="icon"
              style={{
                position: "absolute",
                right: "16px",
                top: "50%",
                transform: "translateY(-50%)",
                width: "24px",
                height: "24px",
                pointerEvents: "none",
              }}
            />
          )}
        </div>
        {!isValid && errorText && (
          <p style={errorStyle}>{errorText}</p>
        )}
      </div>
    </div>
  );
}
